import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const Input = ({ className, type, ...props }: ComponentProps<"input">) => (
  <input
    type={type}
    data-slot="input"
    className={cn(
      "h-10 w-full min-w-0 rounded-lg border border-border bg-background px-3 text-sm text-foreground transition-colors outline-none placeholder:text-subtle focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/60 disabled:pointer-events-none disabled:opacity-50",
      className,
    )}
    {...props}
  />
);
